define('../app/fukit/view/block/form.container.view',['require','exports','module','underscore','uikit/uikit','./label.component.view','../../behavior/grid.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      UIKit              = require('uikit/uikit'),
      LabelComponentView = require('./label.component.view'),
      GridBehavior       = require('../../behavior/grid.behavior');

  var RowView = UIKit.ComponentsContainerView.extend({
    className: 'fields',

    options: {
      inline: false,
      size: null,
      forElementId: '',
    },

    childView: LabelComponentView,

    childViewOptions: function() {
      return {
        forElementId: this.getOption('forElementId'),
      };
    },

    behaviors: {
      GridBehavior: {
        behaviorClass: GridBehavior,
      },
    },

    updateAttributes: function() {
      this.addClass(UIKit.Grid.getSizeClass(this.getOption('size')), this.getBoolOption('size'));
      this.addClass('inline', this.getBoolOption('inline'));
    },
  });

  var FormContainerView = UIKit.ComponentsContainerView.extend({
    className: 'ui form',

    options: {
      basic: false,
      attached: false,
    },

    childView: LabelComponentView,

    updateAttributes: function() {
      var attached = this.getOption('attached');
      this.addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
      this.addClass('segment', !this.getBoolOption('basic'));
    },
  });

  FormContainerView.RowView = RowView;
  module.exports = FormContainerView;
});

